export default __webpack_public_path__ + "static/media/net-hero-background.996b9cc2.svg";